import axios, { AxiosError } from 'axios';

interface AxiosErrorData {
  detail?: unknown;
  error?: unknown;
}

// Define metadata type if you expect any specific shape (or use `Record<string, any>` for flexibility)
type Metadata = Record<string, any>;

// Define the return type of the function
export interface AxiosErrorResult {
  error: string;
  [key: string]: any; // For additional metadata properties
}

export type RequestError = AxiosError<AxiosErrorResult>;

export const axiosErrorMiddleware = (error: unknown, metadata?: Metadata): AxiosErrorResult => {
  if (axios.isAxiosError(error) && error.response?.data) {
    const data = error.response.data as AxiosErrorData;
    const isDetailedError = data.detail;
    const isBasicError = data.error;

    // Detailed error handling
    if (isDetailedError) {
      const errorMessage = JSON.stringify(isDetailedError);
      return metadata ? { error: errorMessage, ...metadata } : { error: errorMessage };
    }

    // Basic error handling
    if (isBasicError) {
      const errorMessage = JSON.stringify(isBasicError);
      return metadata ? { error: errorMessage, ...metadata } : { error: errorMessage };
    }

    // Fallback for axios errors with no detail or error field
    return metadata
      ? { error: 'An unexpected error occurred while running this request.', ...metadata }
      : { error: 'An unexpected error occurred while running this request.' };
  }

  // Non-Axios errors or unexpected errors
  const errorMessage = (error as Error)?.message || 'An unexpected error occurred.';
  return metadata ? { error: errorMessage, ...metadata } : { error: errorMessage };
};
